import type { ButtonHTMLAttributes } from "react";
import { useIdioma } from "../../i18n/IdiomaProvider";
import styles from "./BotaoFechar.module.css";

type BotaoFecharProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "children" | "type"
>;

export function BotaoFechar({
  className,
  "aria-label": ariaLabel = "Fechar",
  ...props
}: BotaoFecharProps) {
  const { traduzir } = useIdioma();
  const classes = className
    ? `${styles.botao} ${className}`
    : styles.botao;

  return (
    <button
      type="button"
      className={classes}
      aria-label={traduzir(String(ariaLabel))}
      {...props}
    >
      <svg
        className={styles.icone}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path d="M6 6l12 12M18 6 6 18" />
      </svg>
    </button>
  );
}
